import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { defaultSelectTestsFormValues, selectTestsSchema, type SelectTestsFormValues } from './SelectTestsStep.schema';

export function useSelectTestsStepForm(defaultValues?: Partial<SelectTestsFormValues>) {
    return useForm<SelectTestsFormValues>({
        mode: 'all',
        defaultValues: { ...defaultSelectTestsFormValues, ...defaultValues },
        resolver: zodResolver(selectTestsSchema),
    });
}
